import React, { useEffect, useState } from 'react'
import { Badge, Button } from 'react-bootstrap'
import { getPayoutsRequest, updatePayoutsRequest } from '../../../Services/AdminServices/adminUserServices';
import { LoaderIcon } from 'react-hot-toast';
import DataTables from '../../Main/DataTable/DataTables';

const AdminWithdrawal = () => {

    const columns = [
        {
            name: 'S.No.',
            selector: (row, index) => index + 1,
            width: '80px',
        },
        { name: 'Name', selector: row => row?.user?.name },
        { name: 'Account Title', selector: row => row.account_title },
        { name: 'Account Number', selector: row => row.account_number },
        { name: 'Amount', selector: row => row.amount },
        {
            name: 'Action',
            cell: row => (
                <div
                    className="d-flex gap-2 flex-nowrap"

                >
                    {row?.status === "Pending" ?
                        <Button
                            onClick={() => updatePayoutStatus(row?.id)}
                            size='sm'
                            variant='outline-success'
                        >
                            {isLoading ? <LoaderIcon /> : "Approve"}
                        </Button>
                        :
                        <Button
                            size='sm'
                            variant='success'
                        >
                            Approved
                        </Button>
                    }

                    {row?.status != "Approved" && (
                        <Button
                            size='sm'
                            variant='outline-danger'
                        >
                            Reject
                        </Button>
                    )}
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }
    ];


    const [isLoading, setIsLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])


    const payoutRequest = async (e) => {
        setLoading(true);
        let response = await getPayoutsRequest();
        if (response.code === 200) {
            setLoading(false);
            console.log("firstfirstfirst", response)
            setData(response?.result?.payouts?.original?.data)
        } else if (response.code === 401) {
            setLoading(false);
        } else {
            // optional: show other errors
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     toast?.error(value);
            // }
            setLoading(false);
        }
    };

    const updatePayoutStatus = async (id) => {
        setIsLoading(true);
        let response = await updatePayoutsRequest(id);
        if (response.code === 200) {
            setIsLoading(false);
            getPayoutsRequest();
        } else if (response.code === 401) {
            setIsLoading(false);
        } else {
            // optional: show other errors
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     toast?.error(value);
            // }
            setIsLoading(false);
        }
    };

    useEffect(() => { payoutRequest() }, [])



    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className='fw-bold mb-0'>Withdrawal Requests</h3>
                        <p className='text-muted'>Manage user withdrawal requests</p>
                    </div>

                    {
                        loading ? (

                            < div style={{ textAlign: 'center', padding: '50px' }}>
                                <div className="spinner-border text-info" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (

                            <DataTables filter={true} columns={columns} data={data} />
                        )
                    }


                </div>


            </div >
        </>
    )
}

export default AdminWithdrawal